import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceEditPersonalWeeklyCalendarNotificationState = createStateReducer(
  initialState,
  {
    [events.editPersonalWeeklyCalendarSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "editPersonalWeeklyCalendar",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.editPersonalWeeklyCalendarFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "editPersonalWeeklyCalendar",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceEditPersonalWeeklyCalendarNotificationState };
